// extracted by mini-css-extract-plugin
export default {"Top":"Landing_Top__WK8qb","Landing":"Landing_Landing__bjrL0"};